<template>
  <div class="content">
    <div class="build-CURD">
      <!-- <div class="build-bar head-title">
        疫情防控日报
      </div> -->
      <div class="build-bar flex-wrap yiqing" style="padding:10px;height:auto;">
        <!-- <el-form label-position="right" label-width="100px" style="text-align: left;">
          <el-form-item label="来源地" style="display:inline-block;">
            <el-select v-model="search.comeProvince" clearable placeholder="不限">
              <el-option
                v-for="item in provinces"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交通方式"   style="display:inline-block;">
            <el-select v-model="search.trafficTools" clearable placeholder="不限">
              <el-option
                v-for="item in traffics"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员类型"   style="display:inline-block;">
            <el-select v-model="search.workType" clearable placeholder="不限">
              <el-option
                v-for="item in workerTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="有无不适症状"   style="display:inline-block;">
            <el-select v-model="search.isNotSick" clearable placeholder="不限">
              <el-option
                v-for="item in isNotSicks"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="有无接触特殊区域/人员" style="display:inline-block;">
            <el-select v-model="search.isNotContact" clearable placeholder="不限">
              <el-option
                v-for="item in isNotContacts"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="体温"   style="display:inline-block;">
            <el-select v-model="search.backTemperature" clearable placeholder="不限">
              <el-option
                v-for="item in backTemperatures"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目名称"   style="display:inline-block;">
            <el-input placeholder="请输入项目名称" v-model="search.name"></el-input>
          </el-form-item>
          <el-form-item label="" style="display:inline-block;">
            <el-button type="primary" icon="el-icon-search" @click="doFilter" style="margin:0;">查询</el-button>
            <el-button type="primary" class="add-user" @click="exportOut">导出报表</el-button>
          </el-form-item>
        </el-form> -->
      </div>
      <div class="build-table">
        <el-table
          :data="listData"
          border
          height="100%"
          style="width: 100%;"
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" type="index" width="60">

          </el-table-column>
          <el-table-column label="总人数">
            <template slot-scope="scope">
              <a>{{ scope.row.headcount}}</a>
            </template>
          </el-table-column>
          <el-table-column label="今日新增" >
            <template slot-scope="scope">
              <span>{{ scope.row.todayNew }}</span>
            </template>
          </el-table-column>
          <el-table-column label="管理人员">
            <template slot-scope="scope">
              <span>{{ scope.row.manages }}</span>
              <!-- <span v-if="scope.row.sex=='1'">男</span>
              <span v-else>女</span> -->
            </template>
          </el-table-column>
          <el-table-column label="务工人员">
            <template slot-scope="scope">
              <span>{{ scope.row.workers }}</span>
            </template>
          </el-table-column>
          <el-table-column label="疫情重点地区人员">
            <template slot-scope="scope">
              <span>{{ scope.row.epidemicAreaPerson }}</span>
            </template>
          </el-table-column>
          <el-table-column label="留宿工地亲属">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.workType=='0'">管理人员</span>
              <span v-else>工人</span> -->
              <span>{{ scope.row.relatives }}</span>
            </template>
          </el-table-column>
          <el-table-column label="体温测试不合格人员">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.isolationWay=='1'" style="color:red;">集中隔离</span>
              <span v-else-if="scope.row.isolationWay=='2'" style="color:#FF8001;">在家隔离</span> -->
              <span>{{ scope.row.aMedicalUnqualified }}</span>
            </template>
          </el-table-column>
          <el-table-column label="总包单位">
            <template slot-scope="scope">
              <span v-if="scope.row.isolationDay">{{ scope.row.constructionUnit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="监理单位">
            <template slot-scope="scope">
              <span>{{ scope.row.supervisionUnit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createDate }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="备注">
            <template slot-scope="scope">
              <span v-if="scope.row.state==1" style="color:#86A0F3">在职</span>
              <span v-else style="color:#FF5722;">离职</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="施工管理人员复工时间">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column> -->
        </el-table>

        <!-- 分页展示 -->
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[3, 5, 10,20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination> -->
      </div>
    </div>
    
    
  </div>
</template>

<script>
import myHttp from '../../../../untils/port'
import base from '../../../../untils/base'
import util from '../../../../untils/util'
export default {
  data() {
    return {
      search:{  //查询
        name:'',
        groupId:'',//项目id
        groupType:'1',//1,项目、2，企业
        //areaId:'',
        //projectType:'1',//项目类型  1：房建   2：市政
        comeProvince:'',//省份（来源地）
        trafficTools:'',//交通方式
        // updateDate:util.myTime.getCurTime(),
        workType:'',//岗位
        isNotSick:'',//生病
        isNotContact:'',//有无接触特殊区域/人员
        backTemperature:'',//体温
      },
      listData:[], //表格数据
      //selectedOptions:["1162316774055600129", "1162316774160457730", "1175657805877567490"],//所选的区域
      areas:[],//区域
      flags:[
        {id:'1',name:'房建'},
        {id:'2',name:'市政'}
      ],
      provinces:[],//省份列表
      traffics:[    //交通方式列表
        {id:'0',name:'自驾'},
        {id:'1',name:'飞机'},
        {id:'2',name:'火车'},
        {id:'3',name:'船舶'},
        {id:'4',name:'长途汽车'}
      ],
      workerTypes:[       //岗位类别   0管理，1工人
        {id:"0",name:'管理人员'},
        {id:"1",name:'工人'},
      ],
      isNotSicks:[      //生病  
        {id:'1',name:'有'},
        {id:'2',name:'无'},
      ],
      isNotContacts:[     //有无接触特殊区域/人员
        {id:'1',name:'有'},
        {id:'2',name:'无'},
      ],
      backTemperatures:[    //体温异常  
        {id:'0',name:'正常'},
        {id:'1',name:'异常'},
      ],
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      myheight:0,
      entId:'',
      port:'',
      dataText:'数据加载中...',
    }
  },
  mounted(){
    // this.entId = this.$store.state.groupId;
    // if(''==this.entId){
    //   this.$store.commit('setGroupId');
    //   this.entId = this.$store.state.groupId;
    // }
    this.port = util.session.get('roleId')
    if(this.$route.params.id=='0'&&this.port=='4'){
        this.search.groupId = util.session.get('groupId')
    }else{
        this.search.groupId = this.$route.params.id;
    }
    // this.search.groupId = this.$route.params.id;
    this.getData();
    // this.getCurArea();
    // this.getArea();//获取所有区域
    // this.getProvice();//获取省份
    // this.uploadData.userId = this.$store.state.user.id;
    // this.uploadData.entId = this.entId;
    // this.getOfficeList();
  },
  methods: {
    // 搜索数据
    doFilter() {
      // this.search.areaId = this.selectedOptions[this.selectedOptions.length-1];
      this.getData()
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val
    //   this.currentChangePage();
    // },
    // // 监控当前页码
    // currentChangePage(list) {
    //   this.getData();
    // },
    //获取所属区域
    getCurArea(){
      var that = this;
      myHttp.getSuperviseById({id:this.entId}).then(function(resp){
        if(resp.data.code=="200"){
          that.search.areaId = resp.data.data.supervise.areaId;
          that.getData();
        }
      },function(){});
    },
    // 获取数据
    getData() {
      var that = this;
      // this.search.pageNum = this.currentPage;
      // this.search.pageSize = this.pageSize;
      myHttp.getDailylist(this.search).then(function(resp){
        if(resp.data.code=="200"){
            var list = resp.data.data.entity||[];
            for(var i=0;i<list.length;i++){
              if(parseFloat(list[i].todayTemperature)>37.3){
                list[i].isTempOver = true
              }else{
                list[i].isTempOver = false
              }
              // list[i].index = that.pageSize*(parseInt(that.currentPage)-1)+(i+1);
            }
            that.listData = list;
            if(that.listData.length==0){
                that.dataText = "暂无数据"
            }
        }else{
          that.$message.error(resp.data.msg);
          that.dataText = "暂无数据"
        }
      },function(){});
    },
    //导出
    exportOut(){
      var token = this.$store.state.token;
      //window.open(myHttp.exportProjectAndIsolationCheck+'?areaId='+this.search.areaId+'&accessToken='+token+"&name="+this.search.name+'&workType='+this.search.workType+'&isNotSick='+this.search.isNotSick+'&isNotContact='+this.search.isNotContact+'&backTemperature='+this.search.backTemperature+'&trafficTools='+this.search.trafficTools+'&comeProvince='+this.search.comeProvince);
    },
    //获取区域
    getArea(){
      var that = this;
      myHttp.getAreaList().then(function(resp){
        if(resp.data.code=="200"){
          var list = resp.data.data.areaList;
          var tree = util.common.listToTree('id','parentId',list);
          that.areas = tree;
        }else{
            that.$message.error(resp.data.msg);
        }
      },function(){});
    },
    /**
     * 获取省份
     */
    getProvice(){
      var that = this;
      myHttp.getProvince().then(function(resp){
        if(resp.data.code=="200"){
          var list = resp.data.data.provinceList;
          that.provinces = list;
        }else{
            that.$message.error(resp.data.msg);
        }
      },function(){});
    },
    //查看
    handleEdit(index,row){

    },
    //监听区域
    selcetKu(data){

    },
    //监听类型
    selcetFlag(data){

    },
  }
}
</script>

<style>
/* @import '../../../assets/css/admin/userMan.css'; */

</style>

<style scoped>
* {
  box-sizing: border-box;
}
.content{
  height: 100%;
  background: #fff;
}
.build-CURD{
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table{
  width: 100%;
  height: calc( 100% - 40px );
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-bar .el-button{
  background-color: #17b2fe;
  border-color: #17b2fe;
  margin-left: 30px;
}
.head-title{
  height:80px;
  border:0;
  padding-left:50px;
  display:flex;
  /* box-shadow: 3px 3px 6px 4px #ddd; */
  font-size: 20px;
  color: #2058D9;
  border-bottom: 10px solid #ecf0f5;
}
.el-pagination{
  padding: 15px 5px;
}
.color-red{
  color: red;
}
.flex-wrap{
  display: flex;
  flex-wrap: wrap;
}
.div-inile{
  display: inline-block;
  width: 300px;
  margin: 0 15px 15px 0;
}
</style>

<style>
.add-form .el-select .el-input{
  width: 100%;
}
.yiqing .el-select .el-input,.yiqing .el-cascader,.yiqing .el-input{
  width: 160px;
}
.yiqing .el-form-item{
  margin-bottom: 15px;
}
.yiqing .el-form-item__label{
    display: flex;
    height: 40px;
    line-height: 20px;
    justify-content: flex-end;
    align-content: center;
    align-items: center;
}
.yiqing input::-webkit-input-placeholder {
  color: #606266;
}
/* .el-form-item__label{
  left: 30px;
  position: relative;
} */
</style>